import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import FeaturedProducts from './components/FeaturedProducts';
import AboutSection from './components/AboutSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Categories />
      <FeaturedProducts />
      <AboutSection />
      <Testimonials />
      <CTASection />
      <BlogSection />
      <Footer />
    </div>
  );
}
